export default {
  default: () => import("D:/workspace/shakeme/client/layouts/default.vue").then(m => m.default || m),
  document: () => import("D:/workspace/shakeme/client/layouts/document.vue").then(m => m.default || m),
  event: () => import("D:/workspace/shakeme/client/layouts/event.vue").then(m => m.default || m),
  member: () => import("D:/workspace/shakeme/client/layouts/member.vue").then(m => m.default || m),
  none: () => import("D:/workspace/shakeme/client/layouts/none.vue").then(m => m.default || m)
}